export default __webpack_public_path__ + "static/media/bg-ring-5.2d451fbb.png";